export const allState = [
  { code: 1, name: "1-JAMMU AND KASHMIR" },
      { code: 2, name: "2-HIMACHAL PRADESH" },
      { code: 3, name: "3-PUNJAB" },
      { code: 4, name: "4-CHANDIGARH" },
      { code: 5, name: "5-UTTARAKHAND" },
      { code: 6, name: "6-HARYANA" },
      { code: 7, name: "7-DELHI" },
      { code: 8, name: "8-RAJASTHAN" },
      { code: 9, name: "9-UTTAR PRADESH" },
      { code: 10, name: "10-BIHAR" },
      { code: 11, name: "11-SIKKIM" },
      { code: 12, name: "12-ARUNACHAL PRADESH" },
      { code: 13, name: "13-NAGALAND" },
      { code: 14, name: "14-MANIPUR" },
      { code: 15, name: "15-MIZORAM" },
      { code: 16, name: "16-TRIPURA" },
      { code: 17, name: "17-MEGHALAYA" },
      { code: 18, name: "18-ASSAM" },
      { code: 19, name: "19-WEST BENGAL" },
      { code: 20, name: "20-JHARKHAND" },
      { code: 21, name: "21-ORISSA" },
      { code: 22, name: "22-CHHATTISGARH" },
      { code: 23, name: "23-MADHYA PRADESH" },
      { code: 24, name: "24-GUJARAT" },
      { code: 25, name: "25-DAMAN AND DIU" },
      { code: 26, name: "26-DADAR AND NAGAR HAVELI" },
      { code: 27, name: "27-MAHARASTRA" },
      { code: 29, name: "29-KARNATAKA" },
      { code: 30, name: "30-GOA" },
      { code: 31, name: "31-LAKSHADWEEP" },
      { code: 32, name: "32-KERALA" },
      { code: 33, name: "33-TAMIL NADU" },
      { code: 34, name: "34-PUDUCHERRY" },
      { code: 35, name: "35-ANDAMAN AND NICOBAR" },
      { code: 36, name: "36-TELANGANA" },
      { code: 37, name: "37-ANDHRA PRADESH" },
      { code: 97, name: "97-OTHER TERRITORY" },
      { code: 99, name: "99-OTHER COUNTRY" },
];
